import { DateToShortIsoString } from '@PetSureAustralia/petsure-react-ui-library/distLib/helpers';
import { dateIsSameOrAfter, dateIsSameOrBefore } from '../utils/date';

export const GetPetDocumentsFromPolicyNumber = ({ petDocuments, policyNumber }) => {
  return Object.entries(petDocuments).reduce((acc, [docType, petDetails]) => {
    if (petDetails.PolicyNumber === policyNumber || petDetails.FullPolicyNumber === policyNumber) {
      acc[docType] = petDetails.PolicyDocuments;
    }
    return acc;
  }, {});
};

export const KeyPetDocumentsByPolicyNumber = ({ petDocuments }) => {
  return Object.entries(petDocuments).reduce((acc, [docType, petDetails]) => {
    petDetails.forEach((petDetail) => {
      if (!acc[petDetail.policyNumber]) {
        acc[petDetail.policyNumber] = {};
      }
      acc[petDetail.policyNumber][docType] =
        petDetail.PolicyDocuments || petDetail.ClaimDocuments || petDetail.OtherDocuments;
    });
    return acc;
  }, {});
};

export const GetClaimDocuments = ({ petDocuments }) => {
  return Object.entries(petDocuments).reduce((acc, [docType, petDetail]) => {
    return [...acc, ...petDetail.ClaimDocuments];
  }, []);
};

export const GetOtherDocuments = ({ petDocuments }) => {
  return Object.entries(petDocuments).reduce((acc, [docType, petDetail]) => {
    return [...acc, ...petDetail.OtherDocuments];
  }, []);
};

export const GetPetDocumentsDateFilterSettings = () => {
  const today = new Date();

  const defaultFromDate = new Date();
  defaultFromDate.setFullYear(defaultFromDate.getFullYear() - 2);

  const tenYearsAgo = new Date();
  tenYearsAgo.setFullYear(tenYearsAgo.getFullYear() - 10);

  const minDate = DateToShortIsoString(tenYearsAgo);
  const maxDate = DateToShortIsoString(today);

  return {
    today,
    defaultFromDate,
    tenYearsAgo,
    minDate,
    maxDate
  };
};

/*
filterSettings = {
  policy: '' or policyNumber,
  fromDate: '' or date object,
  toDate: '' or date object,
}
 */

export const FilterDocuments = ({ documents, filterSettings }) => {
  const { policy, fromDate, toDate } = filterSettings;

  // Cater for receiving FullPolicyNumber instead of short version
  const policyAsNumber = policy ? policy.match(/\d{7}/g)[0] : '';

  return documents.filter((document) => {
    const policyMatch = !policy || policyAsNumber === document.policyNumber;
    const fromDateMatch = !fromDate || dateIsSameOrAfter(fromDate, document.sentDate);
    const toDateMatch = !toDate || dateIsSameOrBefore(toDate, document.sentDate);

    return policyMatch && fromDateMatch && toDateMatch;
  });
};

export const SortDocumentsByDate = ({ documents, descending = true }) => {
  const sortedDocs = documents.sort((documentA, documentB) => {
    const dateA = new Date(documentA.sentDate);
    const dateB = new Date(documentB.sentDate);

    return dateB.getTime() - dateA.getTime();
  });

  return descending ? sortedDocs : sortedDocs.reverse();
};

// Ref: https://stackoverflow.com/questions/50694881/how-to-download-file-in-react-js
export const downloadPdfFile = async (downloadDocument, params, fileName) => {
  try {
    const finalFileName = fileName.toLowerCase().endsWith('.pdf') ? fileName : `${fileName}.pdf`;

    const blob = await downloadDocument(params).unwrap();
    const url = window.URL.createObjectURL(blob);
    const a = Object.assign(document.createElement('a'), { href: url, download: finalFileName });
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Download failed:', error);
  }
};
